export default __webpack_public_path__ + "static/media/Prof-Dr-Ulrich-Anders_Project-Work-Best-Practices-Framework_v1.0.0.45e7cab0.png";